import { ListItem } from '@mui/material';

import { GDMListItemComponent } from './GDMListItem.type';

/* TODO: Implement component using GDM default design */
const GDMListItem: GDMListItemComponent = props => <ListItem {...props} />;

export default GDMListItem;
